import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import ReactSelect2 from '../../elements/ReactSelect2Wrapper'
import cs from 'classnames'
import { DatePicker } from 'components/shared/datePicker'
import { initContract, createContract, setOpenedSubmenu, setClientSubModule, fetchClient } from 'state/actions'
import nesProp from 'nested-property'
import styles from './clientContractCreate.scss'
import i18n from 'lib/i18n'
import moment, { months } from 'moment'
import { CONTRACT_PRE_MANDATE, CONTRACT_PRE_PROPOSAL } from 'state/constants'

const _ = i18n('clientContractCreate')

const customStylesForModal = {
    overlay: {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial', bottom: 'initial', left: 'initial', right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

const fieldsForFill = {
    selectedBroker: '',
    instigatorValue: '',
    contractNumber: '',
    selectedCompany: '',
    selectedStartDate: '', selectedEndDate: '',
    selectedDueDate: '',
    selectedDueDateDay: '',
    selectedDueDateMonth: '',
    selectedPeriodicity: '',
    selectedBranch: '',
    riskDescription1: '',
    riskDescription2: '',
    changeRequest: false,
    commentChangeRequest: '',
}

/**
 * Resetable state hierarchy and values for this module.
 */
const resetableState = {
    allFieldDisabled: true,
    policyHolder: '',
    contractId: '',
    contract: false,
    waitingModal: false,
    validationErrors: {},
    hasError: false,
    ...fieldsForFill
}

/**
 * Default state hierarchy and values for this module.
 */
let permanentState = {
    brokerOptions: [],
    companiesOptions: [],
    periodicityOptions: [],
    branchOptions: [],
    dueDateMonthsOptions: [],
    dueDateDaysOptions: []
}

@connect(state => {

    let clientAccess = state.app.security.actions
    let canCreateMifid = false

    clientAccess.map((item, key) => {
        if (item.actionName == 'createmifid') {
            canCreateMifid = item.actionAllowed === "true" ? true : false
        }
    })

    return ({
        security: state.app.security,
        brokers: state.office.brokers,
        canCreateMifid
    })
})
export default class ClientContractCreate extends React.Component {
    static propTypes = {
        dispatch: React.PropTypes.func.isRequired,
        modalIsOpen: React.PropTypes.bool,
        closeModal: React.PropTypes.func,
        clientId: React.PropTypes.string,
        policyHolder: React.PropTypes.string,
        isPrem: React.PropTypes.bool,
        tarificationNumber: React.PropTypes.string
    }

    /**
     * Pad start function implemented because of IE11 not support
     */
    padStart = (str, targetLength, padString) => {
        str = String(str)
        targetLength = targetLength >> 0 //truncate if number or convert non-number to 0
        padString = String((typeof padString !== 'undefined' ? padString : ' '))
        if (str.length > targetLength) {
            return String(str);
        }
        else {
            targetLength = targetLength - str.length
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(str)
        }
    }

    /**
     * Constructor
     * @param {*} props
     */
    constructor(props) {
        super(props)
        let initDatesValues = this.generateDates()

        permanentState.dueDateMonthsOptions = this.getMonthsOptions()
        permanentState.dueDateDaysOptions = this.getDaysOptions()

        this.state = {
            ...permanentState,
            ...resetableState,
            contract: props.contract,
            policyHolder: props.policyHolder,
            ...initDatesValues
        }
    }

    /**
     * This will give a list for a month selector dropdown
     */
    getMonthsOptions() {
        let months = []
        for (let i = 1; i < 13; i++) {
            months.push({
                value: String(i),
                label: this.padStart(String(i), 2, '0')
            })
        }

        return months
    }

    /**
     * This will give a list for a month selector dropdown
     */
    getDaysOptions(monthNumber = 1) {
        let days = []
        let daysCount = moment(moment().format("YYYY") + "-" + this.padStart(String(monthNumber), 2, '0'), "YYYY-MM").daysInMonth()
        for (let i = 1; i < daysCount; i++) {
            days.push({
                value: String(i),
                label: this.padStart(String(i), 2, '0')
            })
        }

        return days
    }


    /**
     * This will initialize the module after mounting.
     */
    componentDidMount() {
        this.initializeBrokerOptions()
            .then((brokerOptions) => {
                // if only one broker has the current office then select the first one
                if (brokerOptions && brokerOptions.length === 1) {
                    this.handleBrokerChange(
                        brokerOptions[0]
                    )
                }
            })
    }

    /**
     * This function will reset the variable values in the form fields
     */
    resetForm() {
        let initDatesValues = this.generateDates()

        return new Promise((resolve) => {
            this.setState({
                ...resetableState,
                policyHolder: this.props.policyHolder,
                ...initDatesValues
            }, resolve)
        })
    }

    /**
     *  This function validate the form using state.
     */
    validateForm(nextState) {
        const { selectedBroker,
            selectedPeriodicity,
            selectedCompany,
            selectedBranch,
            contractNumber, selectedStartDate, selectedEndDate, selectedDueDate,
            selectedDueDateDay, selectedDueDateMonth, riskDescription1, riskDescription2,
            validationErrors, instigatorValue,
            changeRequest, commentChangeRequest
        } = nextState
        const { isPrem } = this.props

        let errors = validationErrors && { ...validationErrors } || {}
        let hasError = false

        nesProp.set(errors, 'selectedBroker.message', '')
        if (!selectedBroker) {
            nesProp.set(errors, 'selectedBroker.message', _('missingBroker'))
            hasError = true
        }

        nesProp.set(errors, 'instigatorValue.message', '')
        if (isNaN(instigatorValue)) {
            nesProp.set(errors, 'instigatorValue.message', _('instigatorValueIsNotANumber'))
            hasError = true
        }

        nesProp.set(errors, 'selectedPeriodicity.message', '')
        if (!selectedPeriodicity) {
            nesProp.set(errors, 'selectedPeriodicity.message', _('missingPeriodicity'))
            hasError = true
        }

        nesProp.set(errors, 'selectedCompany.message', '')
        if (!selectedCompany) {
            nesProp.set(errors, 'selectedCompany.message', _('missingCompany'))
            hasError = true
        }

        nesProp.set(errors, 'selectedBranch.message', '')
        if (!selectedBranch) {
            nesProp.set(errors, 'selectedBranch.message', _('missingBranch'))
            hasError = true
        }

        nesProp.set(errors, 'contractNumber.message', '')

        nesProp.set(errors, 'selectedStartDate.message', '')
        if (!selectedStartDate) {
            nesProp.set(errors, 'selectedStartDate.message', _('missingStartDate'))
            hasError = true
        } else {
            if (!moment(selectedStartDate, "YYYY-MM-DD").isValid()) {
                nesProp.set(errors, 'selectedStartDate.message', _('wrongFormatStartDate'))
                hasError = true
            } else {
                if (moment().diff(moment(selectedStartDate, "YYYY-MM-DD"), 'days', true) >= 1) {
                    nesProp.set(errors, 'selectedStartDate.message', _('clientContractCreate_createPrevErrorMessage2'))
                    hasError = true
                }
            }

        }

        nesProp.set(errors, 'selectedEndDate.message', '')
        if (!selectedEndDate) {
            nesProp.set(errors, 'selectedEndDate.message', _('missingEndDate'))
            hasError = true
        } else {
            if (!moment(selectedEndDate, "YYYY-MM-DD").isValid()) {
                nesProp.set(errors, 'selectedEndDate.message', _('wrongFormatEndDate'))
                hasError = true
            }
        }

        //let selectedDueDate = String(selectedDueDateDay).padStart(2, "0") + "-" + String(selectedDueDateMonth).padStart(2, "0")

        nesProp.set(errors, 'selectedDueDate.message', '')
        if (!selectedDueDate) {
            nesProp.set(errors, 'selectedDueDate.message', _('missingDueDate'))
            hasError = true
        } else {
            if (!moment(selectedDueDate, "DD-MM").isValid()) {
                nesProp.set(errors, 'selectedDueDate.message', _('wrongFormatDueDate'))
                hasError = true
            }
        }

        if (selectedStartDate && selectedEndDate) {
            let startDate = moment(selectedStartDate, "YYYY-MM-DD")
            let endDate = moment(selectedEndDate, "YYYY-MM-DD")

            if (startDate.isAfter(endDate)) {
                nesProp.set(errors, 'selectedEndDate.message', _('wrongEndDate'))
                hasError = true
            }

            /*  if (selectedDueDate) {
                let dueDate = moment(selectedDueDate, "YYYY-MM-DD")

                if (!dueDate.isSameOrAfter(startDate)) {
                    nesProp.set(errors, 'selectedDueDate.message', _('wrongDueDate'))
                    hasError = true
                }
            } */
        }

        nesProp.set(errors, 'riskDescription1.message', '')
        if ((riskDescription1 && riskDescription1.trim().length > 50)) {
            nesProp.set(errors, 'riskDescription1.message', _('tooLongRiskDescription1'))
            hasError = true
        }

        if ((!riskDescription1)) {
            nesProp.set(errors, 'riskDescription1.message', _('requiredRiskDescription1'))
            hasError = true
        }

        nesProp.set(errors, 'riskDescription2.message', '')
        if ((riskDescription2 && riskDescription2.trim().length > 50)) {
            nesProp.set(errors, 'riskDescription2.message', _('tooLongRiskDescription2'))
            hasError = true
        }

        // must filled in the risk description 1 before fill the risk description 2
        if (!riskDescription1 && riskDescription2) {
            nesProp.set(errors, 'riskDescription2.message', _('missingRiskDescription1'))
            hasError = true
        }

        if (changeRequest && !commentChangeRequest.trim()) {
            nesProp.set(errors, 'commentChangeRequest.message', _('missingChangeRequestComment'))
            hasError = true
        }

        if (isPrem && !contractNumber.trim()) {
            nesProp.set(errors, 'contractNumber.message', _('missingContractNumber'))
            hasError = true
        }

        return { errors, hasError }
    }

    /**
     * This function called in every update of module
     * @param {*} nextProps
     * @param {*} nextState
     */
    componentWillUpdate(nextProps, nextState) {
        // validate the form and check if update required (fields are changed)
        let validation = this.validateForm(nextState)
        let { validationErrors, hasError } = this.state

        // check if update required
        let mustUpdate = validation.hasError !== hasError
        mustUpdate = mustUpdate || (JSON.stringify(validationErrors) !== JSON.stringify(validation.errors))

        // update errors in state if necessary
        if (mustUpdate) {
            this.setState({ validationErrors: validation.errors, hasError: validation.hasError }, () => {
                this.forceUpdate()
            })
        }
    }

    /**
     * Generate the new default values for dates
     * @param {string} predefinedStartDate
     */
    generateDates(predefinedStartDate = null) {
        let startDate = predefinedStartDate ?
            moment(predefinedStartDate, "YYYY-MM-DD").format("YYYY-MM-DD") :
            moment(new Date()).format("YYYY-MM-DD")

        let endDate = moment(startDate, "YYYY-MM-DD").add(1, 'years').subtract(1, 'days').format("YYYY-MM-DD")
        let dueDate = moment(startDate, "YYYY-MM-DD").format("DD-MM")

        return {
            selectedStartDate: startDate,
            selectedEndDate: endDate,
            selectedDueDate: dueDate
        }
    }

    /**
    * This function will set state for the broker selector input.
    * Insert the list of broker like an array contains plain JS objects (label, value).
    */
    initializeBrokerOptions() {
        const { brokers } = this.props
        const brokerObjKeys = brokers && Object.keys(brokers) || []
        const brokerOptions = brokers && Object.keys(brokers).map((brokerKey) => ({
            value: brokers[brokerKey].brokerNumber,
            label: brokers[brokerKey].brokerNumber + " - " + brokers[brokerKey].main.name
        }))

        return new Promise((resolve, reject) => {
            this.setState({ brokerOptions: brokerOptions }, () => {
                resolve(brokerOptions)
            })
        })

    }

    /**
     *  This function initialize the options for the select input in form for companies.
     * @param {array} companiesResult - contains the result of initContract from oracle.
     */
    initializeCompanies(companiesResult) {
        let companiesOptions = []

        if (companiesResult) {
            companiesResult.forEach(element => {
                companiesOptions.push({
                    value: element.companyId,
                    label: element.companyNumber + " " + element.companyName,
                    sortIndex: element.companyNumber
                })
            })
        }

        if (companiesOptions && companiesOptions.length > 0) {
            companiesOptions = companiesOptions.sort((companyA, companyB) => {
                if (Number(companyA.sortIndex) < Number(companyB.sortIndex)) { return -1 }
                if (!Number(companyA.sortIndex) > Number(companyB.sortIndex)) { return 1 }
                if (Number(companyA.sortIndex) === Number(companyB.sortIndex)) { return 0 }
            })
        }

        this.setState({ companiesOptions })
    }

    /**
     *  This function initialize the options for the select input in form for companies.
     * @param {array} periodicityResult - come the result of initContract from oracle.
     */
    initializePeriodicities(periodicityResult) {
        let periodicityOptions = []

        if (periodicityResult) {
            periodicityResult.forEach(element => {
                periodicityOptions.push({
                    value: element.periodicityValue,
                    label: element.periodicityMeaning
                })

                let isDefault = String(element.periodicityDefault).toLowerCase().trim() === "true"
                    ? true
                    : (String(element.periodicityDefault).toLowerCase().trim() === "false" ? false : true)

                // set selected the default
                if (isDefault) {
                    this.handlePeriodicityChange({
                        value: element.periodicityValue,
                        label: element.periodicityMeaning
                    })
                }

            })
        }

        this.setState({ periodicityOptions })
    }

    /**
     *  This function initialize the options for the select input in form for branches.
     * @param {array} branchResult - come the result of initContract from oracle.
     */
    initializeBranch(branchResult, mandate, isOffer) {
        let branchOptions = []
        if (branchResult) {
            branchResult.forEach(element => {
                let elemMandate = element.mandate && element.mandate === 'true' ? true : false
                let elemFromOffer = element.fromOffer && element.fromOffer === 'true' ? true : false

                if (!mandate && !isOffer && !elemFromOffer && !elemMandate) {
                    branchOptions.push(this.createBrachOption(element))
                }
                
                if (mandate && elemMandate) {
                    branchOptions.push(this.createBrachOption(element))
                }
                
                if (elemFromOffer && isOffer) {
                    branchOptions.push(this.createBrachOption(element))
                }
            })
        }

        if (branchOptions && branchOptions.length > 0) {
            branchOptions = branchOptions.sort((branchA, branchB) => {
                if (Number(branchA.sortIndex) < Number(branchB.sortIndex)) { return -1 }
                if (!Number(branchA.sortIndex) > Number(branchB.sortIndex)) { return 1 }
                if (Number(branchA.sortIndex) === Number(branchB.sortIndex)) { return 0 }
            })
        }

        this.setState({ branchOptions })
    }

    /**
     * Create branch element for select list
     * 
     * @param {*} element 
     * @returns 
     */
    createBrachOption(element) {
        return {
            value: element.branche,
            sortIndex: element.branche,
            label: element.branche + " " + element.brancheDescription,
            risk1: element.risk1,
            risk2: element.risk2,
        }
    }

    /**
     *  This function initialize the instigator input visibility.
     * @param {array} instigator - come the result of initContract from oracle.
     */
    initializeInstigator(instigator) {
        let boolInstigator = instigator && (instigator === "true" || instigator === true) ? true : false
        this.setState({ instigator: boolInstigator })
    }

    /**
     * Handle mobile touch
     * @param {*} field
     */
    touch(field) {
        field.onBlur()
    }

    /**
     * This function will disable all fields depending on broker number
     */
    disableFieldsOnEmptyBroker(selectedBrokerNumber) {
        this.setState({ allFieldDisabled: !Boolean(selectedBrokerNumber) })
    }

    /**
     * This function set a field touched
     * @param {string} fieldName - a state property name of this module what contains an input value
     */
    setFieldTouched(fieldName) {
        const { validationErrors } = this.state

        if (typeof fieldName == 'string') {
            nesProp.set(validationErrors, fieldName + '.touched', true)
        } else {
            Object.keys(fieldName).forEach((oneFieldName) => {
                nesProp.set(validationErrors, oneFieldName + '.touched', true)
            })
        }


        this.setState({ validationErrors }, () => {
            // debug place
        })
    }

    handleBrokerChange = (selectedBroker) => {
        let { isPrem: mandate } = this.props
        this.setFieldTouched('selectedBroker')
        this.getDataAfterChange(selectedBroker, mandate)
    }

    //should remove madate change handler this will never change
    getDataAfterChange(selectedBroker, mandate) {
        try {
            let selectedBrokerNr = selectedBroker && selectedBroker.value || ''

            let oldBroker = nesProp.get(this.state, "selectedBroker.value")
            let oldMandate = nesProp.get(this.state, "mandate")

            // no change do nothing
            if (selectedBrokerNr === oldBroker && mandate === oldMandate) {
                return
            }

            // if user changes a preexisting value, a confirmation popup is required
            if (selectedBrokerNr && oldBroker) {
                this.switchWaitingModal(
                    true,
                    _("areYouSureToClearForm"),
                    _("clearForm"),
                    (shouldContinue = true) => {
                        if (shouldContinue) {
                            this.performGetDataAfterChange(selectedBroker, selectedBrokerNr, mandate)
                        }
                        this.switchWaitingModal(false)
                        return
                    })
            } else if (selectedBrokerNr && !oldBroker) {
                this.performGetDataAfterChange(selectedBroker, selectedBrokerNr, mandate)
            }

        } catch (error) {
            console.warn(error);
        }
    }

    /**
     * This function fetches information and sets form fields data when the broker selection is changes
     * @param {*} selectedBroker
     * @param {*} selectedBrokerNr
     * @param {*} mandate
     * @returns  void
     */
    performGetDataAfterChange = async (selectedBroker, selectedBrokerNr, mandate) => {
        try {
            const { dispatch, tarificationNumber } = this.props

            const isOffer = tarificationNumber ? true : false

            // perform change actions
            await this.resetForm()
            // reflect the broker change to the state after resetting the form
            this.setState({ selectedBroker })

            // if empty broker selected nothing to do, no api call required for additional data
            if (!selectedBrokerNr) {

                // hide field, because no broker selected, to initContract to be called,
                // to decide if necessary to show this field
                this.initializeInstigator("false")

                return
            }

            // Call initContract api to get information for the selected broker, the result contains values for the
            // drop-down inputs and risk descriptions, etc.
            // this can be run parallel with the set state of broker until the value not affect the initializations
            await dispatch(initContract(selectedBrokerNr)).then((result) => {

                // init companies options for select
                this.initializeCompanies(result && result.companies)

                // init periodicity options for select
                this.initializePeriodicities(result && result.periodicities)

                // init periodicity options for select
                this.initializeBranch(result && result.branche, mandate, isOffer)

                // init instigator field
                this.initializeInstigator(result && result.instigator)

            })

            this.disableFieldsOnEmptyBroker(selectedBroker && selectedBroker.value)

        } catch (error) {
            console.warn(error);
        }
    }


    /**
     * This function handle the onChange of the company select input.
     * @param {object} selectedCompany - select input value to set in state for handle form.
     */
    handleCompanyChange(selectedCompany) {
        this.setFieldTouched('selectedCompany')
        this.setState({ selectedCompany })
    }

    /**
     * This function handle the onChange of the periodicity select input.
     * @param {object} selectedPeriodicity - select input value to set in state for handle form.
     */
    handlePeriodicityChange(selectedPeriodicity) {
        this.setFieldTouched('selectedPeriodicity')
        this.setState({ selectedPeriodicity })
    }


    /**
     * This function handle the onChange of the branch select input.
     * @param {object} selectedBranch - select input value to set in state for handle form.
     */
    handleBranchChange(selectedBranch) {
        this.setFieldTouched('selectedBranch')
        this.setState({ selectedBranch })
    }

    /**
     * This function handle the input change of due date month.
     * @param {*} selectedDueDateMonth
     */
    /* handleDueDateMonthChange(selectedDueDateMonth) {
        this.setFieldTouched('selectedDueDateMonth')
        this.setFieldTouched('selectedDueDate')

        let selectedDueDateDay = this.state.selectedDueDateDay

        this.setState({ selectedDueDate: String(selectedDueDateDay).padStart(2, "0") + "-" + String(selectedDueDateMonth).padStart(2, "0") })
        this.setState({ selectedDueDateMonth })
    } */

    /**
     * This function handle the input change of due date say.
     * @param {*} selectedDueDateDay
     */
    /* handleDueDateDayChange(selectedDueDateDay) {
        this.setFieldTouched('selectedDueDateDay')
        this.setFieldTouched('selectedDueDate')

        let selectedDueDateMonth = this.state.selectedDueDateMonth

        this.setState({ selectedDueDate: String(selectedDueDateDay).padStart(2, "0") + "-" + String(selectedDueDateMonth).padStart(2, "0") })
        this.setState({ selectedDueDateDay })
    } */

    /**
     * This function
     * @param {*} isConfirmed
     */
    async handleCloseModel(isConfirmed) {
        const { closeModal, dispatch, clientId, tarificationNumber } = this.props
        const isPrev = nesProp.get(this.props, "isPrem") ? false : true

        if (!isConfirmed) {
            this.setState(resetableState)
            return closeModal()
        }

        // prepare params for api call
        let createContractParams = {}
        //get the mandate from props and will have to handle the 2 new fields for Prem
        createContractParams.mandate = nesProp.get(this.props, "isPrem")
        createContractParams.mandateNumber = nesProp.get(this.state, "contractNumber")
        createContractParams.instigatorValue = nesProp.get(this.state, "instigatorValue")
        createContractParams.clientId = clientId
        createContractParams.brokerNumber = nesProp.get(this.state, "selectedBroker.value")
        createContractParams.companyId = nesProp.get(this.state, "selectedCompany.value")
        createContractParams.contractStartDate = nesProp.get(this.state, "selectedStartDate")
        createContractParams.contractEndDate = nesProp.get(this.state, "selectedEndDate")
        createContractParams.dueDate = nesProp.get(this.state, "selectedDueDate")
        createContractParams.periodityValue = nesProp.get(this.state, "selectedPeriodicity.value")
        createContractParams.branch = nesProp.get(this.state, "selectedBranch.value")
        createContractParams.riskValue1 = nesProp.get(this.state, "riskDescription1").trim()
        createContractParams.riskValue2 = nesProp.get(this.state, "riskDescription2").trim()
        createContractParams.changeRequest = nesProp.get(this.state, "changeRequest") ? '1' : '0'
        createContractParams.commentChangeRequest = nesProp.get(this.state, "commentChangeRequest").trim()
        if (tarificationNumber) {
            createContractParams.tarificationNumber = tarificationNumber
        }

        try {
            const result = await dispatch(createContract(createContractParams))
            let error = nesProp.get(result, "error")
            if (error && String(error) !== '0' && String(error) !== '') {
                throw error
            }

            //determine what kind of contract has been saved (PREM or PREV)

            //Show the modal with the success messages
            this.switchWaitingModal(
                true,
                isPrev ? _("createPrevSuccessMessage") : _("createPremSuccessMessage"),
                isPrev ? _("createPrevSuccessTitle") : _("createPremSuccessTitle"),
                (shouldContinue = true) => {
                    this.switchWaitingModal(false)
                    let contractNumber = nesProp.get(result, "contractNumber")
                    let contractId = nesProp.get(result, "contractId")

                    this.setState({ contractId: contractId })
                    this.setState({ contractNumber: contractNumber })
                    this.setState({ mandate: true })

                    dispatch(fetchClient(clientId)).then(() => {
                        dispatch(setClientSubModule(
                            'contracts',
                            { contractNumber },
                            isPrev ? CONTRACT_PRE_PROPOSAL : CONTRACT_PRE_MANDATE
                        ))
                    })

                    this.handleCloseModel(false)
                }
            )


        } catch (err) {
            let error = nesProp.get(err, "error")
            let errorCode = Number(error)

            // if error code not in the list then that is not recognized by the system and set
            // to the unknown error
            if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].indexOf(errorCode) == -1) {
                errorCode = 3
            }

            // show notification modal about error
            this.switchWaitingModal(
                true,
                _("createPrevErrorMessage" + errorCode),
                _("createPremErrorTitle"),
                (shouldContinue = true) => {
                    this.switchWaitingModal(false)
                }
            )
        }

    }

    /**
     * This function handle the waiting modal
     * @param {bool} show - modal show or hide
     * @param {string} text - modal content
     * @param {string} title - modal title
     * @param {function} waitingModalOkButtonCallback is empty the no button shown, else ok button call
     */
    switchWaitingModal(show = true, text = "", title = "", waitingModalOkButtonCallback = null, waitingModalOkButtonLink = null) {
        this.setState({
            waitingModal: show,
            waitingModalText: text,
            waitingModalTitle: title,
            waitingModalOkButtonCallback: waitingModalOkButtonCallback,
            waitingModalOkButtonLink: waitingModalOkButtonLink,
        })
    }

    /**
     *  This function render the waiting modal content until the zipped documents prepare.
     */
    waitingPopup() {
        const { waitingModalText, waitingModalTitle, waitingModalOkButtonCallback, waitingModal } = this.state
        return (
            <Modal
                isOpen={waitingModal}
                style={customStylesForModal}
                className={styles.modal}
                key={"archiveConfirmPopupKey"}
                contentLabel={""}
            >
                <div className={styles.title}>{waitingModalTitle}</div>
                <div className={styles.contentWrapper}>
                    <div className={styles.content} key={"formContainerKey"}>
                        <div className={styles.whitespacePre}>{waitingModalText}</div>
                        {waitingModalOkButtonCallback && typeof waitingModalOkButtonCallback == 'function' &&
                            <div className={styles.buttons} key={"closeModalKey"}>
                                <div
                                    onClick={() => (waitingModalOkButtonCallback(false))}
                                    className={styles.cancel}
                                >
                                    {_("cancel")}
                                </div>
                                <div
                                    className={cs(styles.next, styles.enabled)}
                                    onClick={() => (waitingModalOkButtonCallback(true))}
                                >
                                    {_('ok')}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        )
    }

    /**
     * This function handle the start date change. Update the due date if necessary.
     */
    handleChangeStartDate(value) {
        const { selectedDueDate } = this.state
        let forceDuedate = selectedDueDate
        this.setFieldTouched('selectedStartDate')
        let dueDateMoment = moment(selectedDueDate, "DD-MM")
        let startDateMoment = moment(value, "YYYY-MM-DD")

        // change the dueDate if: no valid due date
        // && dueDateMoment.isBefore( startDateMoment )

        if (!dueDateMoment.isValid() || startDateMoment.isValid()) {
            let setThisValueForDueDate = startDateMoment && startDateMoment.format("DD-MM")
            this.setState({ selectedDueDate: setThisValueForDueDate })
        }

        // when start date set, then automatically set the end date also like the due date
        if (startDateMoment.isValid()) {
            let generateDates = this.generateDates(startDateMoment.format("YYYY-MM-DD"))
            let newSelectedEndDate = generateDates.selectedEndDate
            this.setState({ selectedEndDate: newSelectedEndDate })
        }

        this.setState({ selectedStartDate: value })
    }

    /**
     * Main render method
     */
    render() {
        const { modalIsOpen, closeModal, isPrem, canCreateMifid, clientId } = this.props
        const { allFieldDisabled, brokerOptions, selectedBroker,
            periodicityOptions, selectedPeriodicity,
            companiesOptions, selectedCompany,
            branchOptions, selectedBranch, policyHolder,
            contractNumber, selectedStartDate, selectedEndDate, selectedDueDate,
            riskDescription1, riskDescription2, validationErrors, hasError,
            dueDateMonthsOptions, dueDateDaysOptions, selectedDueDateDay, selectedDueDateMonth,
            instigator, instigatorValue, contractId, changeRequest, commentChangeRequest
        } = this.state

        return (
            <div>
                <Modal
                    isOpen={modalIsOpen}
                    onCancel={closeModal}
                    style={customStylesForModal}
                    className={styles.modal}
                    contentLabel={""}
                >
                    {
                        isPrem ?
                            <div className={styles.title}>
                                {_("createMandateModalTitle")}
                            </div>
                            :
                            <div className={styles.title}>
                                {_("createContractModalTitle")}
                            </div>
                    }
                    <div className={styles.contentWrapper} key={"contentWrapperKey"}>
                        <div className={styles.content} key={"formContainerKey"}>
                            <form method="post" className={styles.form}>
                                <div className={styles.inputRow} key={"brokerNumberKey"}>
                                    <label className={styles.inputLabel}>{_("brokerNumber")}</label>
                                    <ReactSelect2
                                        value={selectedBroker}
                                        onChange={(value) => {
                                            return this.handleBrokerChange(value)
                                        }}
                                        options={brokerOptions}
                                        // openMenuOnFocus={true} - removed this line as it causes the select dropdown to appear after confirmation modal
                                        placeholder={''}
                                        onBlurResetsInput={false}
                                        isSearchable
                                        isClearable
                                    />
                                </div>

                                {nesProp.get(validationErrors, "selectedBroker.message") && nesProp.get(validationErrors, "selectedBroker.touched") &&
                                    <div className={styles.inputRow} key={"brokerNumberErrorKey"}>
                                        <div className={styles.inputRowError}>{validationErrors.selectedBroker.message}</div>
                                    </div>}

                                {
                                    instigator &&
                                    <div className={styles.inputRow} key={"instigatorKey"}>
                                        <label className={styles.inputLabel}>{_("applicantNumber")}</label>
                                        <input type="text"
                                            className={styles.instigatorInput}
                                            disabled={allFieldDisabled}
                                            value={instigatorValue}
                                            onChange={(value) => {
                                                this.setFieldTouched('instigatorValue')
                                                this.setState({ instigatorValue: value && value.target.value || "" })
                                            }
                                            }
                                        />
                                    </div>
                                }

                                {nesProp.get(validationErrors, "instigatorValue.message") && nesProp.get(validationErrors, "instigatorValue.touched") &&
                                    <div className={styles.inputRow} key={"instigatorValueErrorKey"}>
                                        <div className={styles.inputRowError}>{validationErrors.instigatorValue.message}</div>
                                    </div>}

                                <div className={styles.inputRow} key={"policyHolderKey"}>
                                    <label className={styles.inputLabel}>{_("policyHolder")}</label>
                                    <input
                                        type="text"
                                        className={styles.contractInput}
                                        value={policyHolder}
                                        disabled={true}
                                    />
                                </div>

                                {isPrem ?
                                    <div className={styles.inputRow} key={"contractNumberKey"}>
                                        <label className={styles.inputLabel}>{_("contractNumber")}</label>
                                        <input type="text"
                                            className={styles.contractInput}
                                            disabled={allFieldDisabled}
                                            value={contractNumber}
                                            onChange={(value) => {
                                                this.setFieldTouched('contractNumber')
                                                this.setState({ contractNumber: value && value.target.value || "" })
                                            }
                                            }
                                        />
                                    </div>
                                    : null
                                }
                                {isPrem ?
                                    nesProp.get(validationErrors, "contractNumber.message") && nesProp.get(validationErrors, "contractNumber.touched") &&
                                    <div className={styles.inputRow} key={"contractNumberErrorKey"}>
                                        <div className={styles.inputRowError}>{validationErrors.contractNumber.message}</div>
                                    </div>
                                    : null
                                }

                                <div className={styles.inputRow} key={"companyKey"}>
                                    <label className={styles.inputLabel}>{_("company")}</label>
                                    <ReactSelect2
                                        options={companiesOptions}
                                        value={selectedCompany}
                                        onChange={(value) => (this.handleCompanyChange(value))}
                                        isSearchable
                                        isClearable
                                        placeholder={''}
                                        isDisabled={allFieldDisabled}
                                        className={cs("identificationForCompanySelector")}
                                        onBlur={(e) => {
                                            // this is a fix for an issue of IE11, to disable dropdown autoclose
                                            // when scroll by clicking with cursor on scrollbar
                                            const focusedElement = document.activeElement
                                            const parentClassName = nesProp.get(focusedElement, "parentElement.parentElement.parentElement.className")
                                            let isItSelf = String(parentClassName).includes("identificationForCompanySelector")

                                            if (isItSelf) {

                                                e.cancelBubbling = true

                                                e.stopPropagation()
                                                //e.stopImmediatePropagation()
                                                e.preventDefault()

                                                e.nativeEvent.cancelBubbling = true

                                                e.nativeEvent.stopPropagation()
                                                e.nativeEvent.stopImmediatePropagation()
                                                e.nativeEvent.preventDefault()
                                                throw null

                                                return false
                                            }
                                        }}
                                    />
                                </div>

                                {nesProp.get(validationErrors, "selectedCompany.message") && nesProp.get(validationErrors, "selectedCompany.touched") &&
                                    <div className={styles.inputRow} key={"companyErrorKey"}>
                                        <div className={styles.inputRowError}>{validationErrors.selectedCompany.message}</div>
                                    </div>}

                                <div className={styles.inputRow} key={"startDateEndDateKey"}>
                                    <div className={styles.column} key={"startDateKey"}>
                                        <div className={styles.inputRow}>
                                            <label className={styles.pickerLabel}>{_("startDate")}</label>
                                            <span className={styles.contractDateInputContainer}>
                                                <DatePicker
                                                    className={allFieldDisabled ? styles.contractDateInputDisabled : styles.contractDateInput}
                                                    disabled={allFieldDisabled}
                                                    onChange={(value) => {
                                                        this.handleChangeStartDate(value)
                                                    }}
                                                    minDate={moment().format()}
                                                    startDate={selectedStartDate}
                                                    endDate={selectedEndDate}
                                                    value={selectedStartDate || moment().format()}
                                                    dateError={() => {}}
                                                    onBlur={(value) => {
                                                        const strValue = moment(value).format("YYYY-MM-DD")
                                                        this.handleChangeStartDate(strValue)
                                                    }}
                                                />
                                            </span>
                                        </div>
                                        {nesProp.get(validationErrors, "selectedStartDate.message") && nesProp.get(validationErrors, "selectedStartDate.touched") &&
                                            <div className={styles.inputRow} key={"startDateEndDateErrorKey"}>
                                                <div className={styles.inputRowError}>{validationErrors.selectedStartDate.message}</div>
                                            </div>}
                                    </div>
                                    <div className={styles.column} key={"endDateKey"}>
                                        <div className={styles.inputRow}>
                                            <label className={styles.pickerLabel}>{_("endDate")}</label>
                                            <span className={styles.contractDateInputContainer}>
                                                <DatePicker
                                                    className={styles.contractDateInput}
                                                    disabled={allFieldDisabled}
                                                    onChange={(value) => {
                                                        this.setFieldTouched('selectedEndDate')
                                                        this.setState({ selectedEndDate: value })
                                                    }
                                                    }
                                                    minDate={moment().format()}
                                                    startDate={selectedStartDate}
                                                    endDate={selectedEndDate}
                                                    value={selectedEndDate}
                                                    dateError={() => {}}
                                                />
                                            </span>
                                        </div>
                                        {nesProp.get(validationErrors, "selectedEndDate.message") && nesProp.get(validationErrors, "selectedEndDate.touched") &&
                                            <div className={styles.inputRow} key={"startDateEndDateError2Key"}>
                                                <div className={styles.inputRowError}>{validationErrors.selectedEndDate.message}</div>
                                            </div>}
                                    </div>
                                </div>

                                <div className={styles.inputRow} key={"dueDateKey2"}>
                                    <label className={styles.dueDateLabel}>{_("dueDate")}</label>
                                    <span className={styles.contractDateInputContainerLong}>
                                        <input
                                            type="text"
                                            className={styles.contractInput}
                                            disabled={allFieldDisabled}
                                            value={selectedDueDate}
                                            maxLength="5"
                                            onChange={(value) => {
                                                this.setFieldTouched('selectedDueDate')
                                                this.setState({ selectedDueDate: value.target.value })
                                            }}
                                            onBlur={() => {
                                                let momentDueDate = moment(selectedDueDate, "DD-MM")
                                                let momentStartDate = moment(selectedStartDate, "YYYY-MM-DD")

                                                if (momentDueDate.isValid()) {
                                                    this.setState({ selectedDueDate: momentDueDate.format("DD-MM") })
                                                } else {
                                                    if (momentStartDate.isValid()) {
                                                        this.setState({ selectedDueDate: momentStartDate.format("DD-MM") })
                                                    }
                                                }
                                            }}
                                        />
                                    </span>
                                </div>

                                {nesProp.get(validationErrors, "selectedDueDate.message") && nesProp.get(validationErrors, "selectedDueDate.touched") &&
                                    <div className={styles.inputRow} key={"dueDateErrorKey"}>
                                        <div className={styles.inputRowError}>{validationErrors.selectedDueDate.message}</div>
                                    </div>}

                                <div className={styles.inputRow} key={"periodicityKey"}>
                                    <label className={styles.inputLabel}>
                                        {_("periodicity")}
                                    </label>
                                    <ReactSelect2
                                        options={periodicityOptions}
                                        value={selectedPeriodicity}
                                        onChange={(value) => (this.handlePeriodicityChange(value))}
                                        isSearchable
                                        isClearable
                                        placeholder={''}
                                        isDisabled={allFieldDisabled}
                                    />
                                </div>

                                {nesProp.get(validationErrors, "selectedPeriodicity.message") && nesProp.get(validationErrors, "selectedPeriodicity.touched") &&
                                    <div className={styles.inputRow} key={"periodicityErrorKey"}>
                                        <div className={styles.inputRowError}>{validationErrors.selectedPeriodicity.message}</div>
                                    </div>}

                                <div className={styles.inputRow} key={"branchKey"}>
                                    <label className={styles.inputLabel}>{_("branch")}</label>
                                    <ReactSelect2
                                        options={branchOptions}
                                        value={selectedBranch}
                                        onChange={(value) => (this.handleBranchChange(value))}
                                        isSearchable
                                        isClearable
                                        placeholder={''}
                                        isDisabled={allFieldDisabled}
                                    />
                                </div>

                                {nesProp.get(validationErrors, "selectedBranch.message") && nesProp.get(validationErrors, "selectedBranch.touched") &&
                                    <div className={styles.inputRow} key={"branchErrorKey"}>
                                        <div className={styles.inputRowError}>{validationErrors.selectedBranch.message}</div>
                                    </div>}

                                <div className={styles.inputRow} key={"riskDescriptionContainerKey"}>
                                    <div className={cs(styles.labelColumn, styles.riskDescriptionsLabel)} key={"risk1Key"}>
                                        <div className={styles.inputRow} key={"riskDescriptionKey"}>
                                            <label className={styles.inputLabel}>{_("riskDescription")}</label>
                                        </div>
                                    </div>
                                    <div className={styles.labelColumn} key={"risk2Key"}>
                                        <div className={styles.inputRow} key={"riskInputKey"}>

                                            <input
                                                type="text"
                                                className={styles.contractInput}
                                                disabled={allFieldDisabled}
                                                value={riskDescription1}
                                                onChange={(value) => {
                                                    this.setFieldTouched('riskDescription1')
                                                    this.setState({ riskDescription1: value && value.target.value || "" })
                                                }
                                                }
                                                placeholder={selectedBranch && selectedBranch.risk1 || ''}
                                            />
                                        </div>

                                        {nesProp.get(validationErrors, "riskDescription1.message") && nesProp.get(validationErrors, "riskDescription1.touched") &&
                                            <div className={styles.inputRow} key={"riskInputErrorKey"}>
                                                <div className={styles.inputRowError}>{validationErrors.riskDescription1.message}</div>
                                            </div>}

                                        <div className={styles.inputRow} key={"risk2Key"}>
                                            <input
                                                type="text"
                                                className={styles.contractInput}
                                                disabled={allFieldDisabled || !riskDescription1}
                                                value={riskDescription2}
                                                onChange={(value) => {
                                                    this.setFieldTouched('riskDescription2')
                                                    this.setState({ riskDescription2: value && value.target.value || "" })
                                                }
                                                }
                                                placeholder={selectedBranch && selectedBranch.risk2 || ''}
                                            />
                                        </div>

                                        {nesProp.get(validationErrors, "riskDescription2.message") && nesProp.get(validationErrors, "riskDescription2.touched") &&
                                            <div className={styles.inputRow} key={"risk2InputErrorKey"}>
                                                <div className={styles.inputRowError}>{validationErrors.riskDescription2.message}</div>
                                            </div>}
                                    </div>
                                </div>

                                {isPrem ?
                                    <div>
                                        <div key={"changeRequestKey"}>
                                            <div className={styles.changeRequestField}>
                                                <label className={styles.changeRequestInputLabel} >{_("changeRequestLabel")}</label>
                                                <input
                                                    className={styles.changeRequest}
                                                    type="checkbox"
                                                    checked={changeRequest}
                                                    disabled={allFieldDisabled}
                                                    onChange={(ev) => {
                                                        ev.stopPropagation()
                                                        this.setState({ changeRequest: !changeRequest })
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {changeRequest ?
                                            <div>
                                                <div className={styles.changeRequestField} key={"commentChangeRequestLabelKey"}>
                                                    <div className={styles.commentChangeRequestInputLabelWrapper}>
                                                        <div className={styles.commentChangeRequestInputLabelDiv}>
                                                            <label className={styles.commentChangeRequestInputLabel}>{_("commentChangeRequestLabel")}</label>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className={styles.changeRequestField} key={"commentChangeRequestTextareaKey"}>
                                                    <textarea
                                                        className={styles.commentChangeRequestText}
                                                        ref="commentChangeRequest"
                                                        rows={'3'}
                                                        value={String(commentChangeRequest || '')}
                                                        onChange={(value) => {
                                                            this.setFieldTouched('commentChangeRequest')
                                                            this.setState({ commentChangeRequest: value && value.target.value || "" })
                                                        }
                                                        }
                                                    />
                                                </div>
                                                {nesProp.get(validationErrors, "commentChangeRequest.message") && nesProp.get(validationErrors, "commentChangeRequest.touched") && !commentChangeRequest &&
                                                    <div className={styles.inputRow} key={"mentionInputErrorKey"}>
                                                        <div className={styles.inputRowError}>{validationErrors.commentChangeRequest.message}</div>
                                                    </div>
                                                }
                                            </div>
                                            : null
                                        }

                                        <div className={styles.inputRow} key={"pleaseConfirmThePremProposalKey"}>
                                            <label className={cs(styles.inputLabel, styles.confirmProposalText)}>
                                                {_("pleaseConfirmThePremProposal")}
                                            </label>
                                        </div>
                                    </div>
                                    :
                                    <div className={styles.inputRow} key={"pleaseConfirmTheProposalKey"}>
                                        <label className={cs(styles.inputLabel, styles.confirmProposalText)}>
                                            {_("pleaseConfirmTheProposal")}
                                        </label>
                                    </div>
                                }
                                <div className={styles.buttons} key={"closeModalKey"}>
                                    <div
                                        key={"closeModalCanceKey"}
                                        onClick={() => { this.handleCloseModel(false) }}
                                        className={cs(styles.cancel)}
                                    >
                                        {_("cancel")}
                                    </div>

                                    <div
                                        key={"closeModalConfirmKey"}
                                        onClick={() => {
                                            if (!hasError) {
                                                this.handleCloseModel(true)
                                            } else {
                                                this.setFieldTouched(fieldsForFill)
                                            }
                                        }}
                                        className={cs(styles.next, styles.enabled)}
                                    >
                                        {_("confirm")}
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </Modal>
                {this.waitingPopup()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/clients/clientContractCreate.jsx